export default "__VITE_ASSET__beaca506__"